(function () {
  'use strict';

  angular.module('ringbaPortal').component('primaryButton', {
    bindings: {
      customClass: '@',
      sizeClass: '@',
      disabled: '<ngDisabled',
      preventInvalid: '<',
      formToValidate: '<',
      submitButton: '<', // True/false to set type="submit" or type="button"
      onClick: '&'
    },
    transclude: true,
    controller: PrimaryButtonController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/primary-button/primary-button.view.html'
  });

  function PrimaryButtonController($q) {
    'ngInject';

    const vm = this;

    vm.validateOnClick = validateOnClick;

    function validateOnClick() {
      if (!vm.preventInvalid) {
        vm.clicked = false;
        return vm.onClick();
      } else {
        if (vm.formToValidate) {
          vm.formToValidate.$setSubmitted();
          vm.clicked = true;
          angular.forEach(vm.formToValidate.$error.required, function (field) {
            field.$setDirty();
            field.$setTouched();
          });
          // The ngIntlTelInput directive breaks the required validator, so we check for this error
          angular.forEach(vm.formToValidate.$error.ngIntlTelInput, function (field) {
            if (field.$validators.required) {
              field.$setDirty();
              field.$setTouched();
            }
          });
        }
        return $q.when({});
      }
    }
  }
})();
